/** Small formatting helpers shared by the admin console's screens. */

/**
 * Format an ISO timestamp as `DD/MM/YYYY`, the console's date format
 * (`docs/ADMIN.md` §3.6's CSV export uses the same one).
 *
 * @param iso - An ISO 8601 timestamp.
 * @returns The `DD/MM/YYYY` date.
 */
export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(iso));
}

/**
 * Format a share in `[0, 1]` as a French percentage, e.g. `0.164` → `"16 %"`.
 *
 * @param share - A ratio between 0 and 1.
 * @returns The rounded percentage, with a narrow non-breaking space before `%`.
 */
export function formatShare(share: number): string {
  return `${Math.round(share * 100)} %`;
}

/**
 * Format a quality average out of 5, French decimal comma, or a dash.
 *
 * @param average - The average quality, or `null` when there is none yet.
 * @param dash - The placeholder to show for `null`.
 * @returns The formatted average.
 */
export function formatQuality(average: number | null, dash = '—'): string {
  if (average === null) return dash;
  return average.toString().replace('.', ',');
}
